module.exports = __webpack_public_path__ + "static/media/Crunch (87 Jubilee) VR.a236c6f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/Crunch (87 Jubilee) VR.mp3
// module id = NYOS
// module chunks = 13